/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module heading
 */

export { default as Heading } from './heading';
export { default as HeadingEditing } from './headingediting';
export { default as HeadingUI } from './headingui';
export { default as HeadingButtonsUI } from './headingbuttonsui';
export { default as Title } from './title';
